<template>
  <div class="home">
    <div class="stats">
      <div class="stat-block">
        <label>Building</label>
        <span class="value">{{totalEmissions}}</span>
        <span class="unit">CO2 (kg)</span>
      </div>
      <div class="stat-block">
        <label>Transportation</label>
        <span class="value">{{totalTransport}}</span>
        <span class="unit">CO2 (kg)</span>
      </div>
      <div class="stat-block">
        <label>Raw material</label>
        <span class="value">{{totalSource}}</span>
        <span class="unit">CO2 (kg)</span>
      </div>
      <div class="stat-block">
        <label>Raw -> Final</label>
        <span class="value">{{totalDifference}}</span>
        <span class="unit">CO2 (kg)</span>
      </div>
      <div class="option-block">
        <span @click="() => currentView = 'sankey'" v-bind:class="{'view-option': true, active: currentView == 'sankey'}">Sankey</span>
        <span @click="() => currentView = 'map'" v-bind:class="{'view-option': true, active: currentView == 'map'}">Map</span>
      </div>
    </div>
    <sankey-chart v-show="currentView == 'sankey'" :chartData="chartData"/>
    <map-chart v-show="currentView == 'map'" :chartData="chartData"/>
  </div>
</template>

<script>
// @ is an alias to /src
import SankeyChart from '@/components/SankeyChart.vue'
import MapChart from '@/components/MapChart.vue'

import d3 from '@/utils/d3importer'
import _ from 'underscore'

export default {
  name: 'Home',
  components: {
    SankeyChart,
    MapChart
  },
  data () {
    return {
      chartData: [],
      currentView: 'sankey'
    }
  },
  mounted() {
    // load the data (using the timelyportfolio csv method)
    d3.csv("data/quarantine-cabin.csv", d3.autoType).then((data) => {
      this.chartData = data
    });
  },
  computed: {
    totalEmissions () {
      return _.reduce(this.chartData, (sum, node) => sum + +node['Average Embodied Carbon (kg CO2e)'] , 0).toFixed(2)
    },
    totalTransport () {
      return _.reduce(this.chartData, (sum, node) => sum + +node['Transport 1'] + +node['Transport 2'] , 0).toFixed(2)
    },
    totalSource () {
      return _.reduce(this.chartData, (sum, node) => sum + +node['Sourcing'], 0).toFixed(2)
    },
    totalDifference () {
      return Math.abs(this.totalSource - this.totalEmissions).toFixed(2)
    },
  }
}
</script>

<style lang="stylus" scoped>
.stats
  min-height 40px
  border-bottom 2px solid #000
  margin-bottom 10px
  display flex
  .stat-block
    margin-right 100px
    label
      font-size 12px
      text-transform uppercase
      margin-right 5px
      display block
    .value
      font-size 20px
      font-weight bold
    .unit
      font-size 7px


  .option-block
    margin-left auto
    margin-bottom 4px
    .view-option
      display inline-block
      padding 10px
      border 2px solid #000
      cursor pointer
      color #000
      background none
      min-width 60px
      font-size 13px
      text-align center
      &.active
        color #ffffff
        background #000
        font-weight bold

</style>
